<template>
  <div id="match-ranking">
    <div class="title">赛事名次</div>
    <div v-if="list.length > 0" class="match-ranking-box">
      <div class="item" :style="{'background-color': item.finalRank == 1 ? '#FFF2B5' : (item.finalRank == 2 ? '#E4E8F3' : (item.finalRank == 3 ? '#E9BD8E' : '#F9FAFC'))}" v-for="item in list" :key="item.id">
        <div>{{ item.finalRank }}</div>
        <img :src="filterImage(item.badge, 42)">
        <p>{{ item.name }}</p>
      </div>
    </div>
    <div v-else style="display: flex; flex-flow: column; align-items: center; padding-top: 20px; ">
      <img src="../../assets/others/empty-team.png" alt="" style="width: 70px;">
      <div style="color: #333333; font-size: 14px; margin-top: 8px">比赛尚未结束，名次敬请期待</div>
    </div>
  </div>
</template>

<script>
import { QNImageUtil } from '@/utils'

import { getBMMatchRankList } from '@/api/match.js'
export default {
    data() {
      return {
        match: {},
        list: [],
        one: {},
        two: {},
        three: {},
        allList: []
      };
  },
  mounted() {
    this.matchId = this.$route.query.matchId
    this.getBMMatchRankList()
  },
    methods: {
      getBMMatchRankList() {
        getBMMatchRankList({ matchId: this.matchId }).then(res => {
          var data = res.data
          this.match = data.match
          this.list = data.list || []
      })
      },
      filterImage(img, w, h, mode) {
        return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
      },
    },
};
</script>

<style scoped lang="scss">
div{
   box-sizing: border-box;
}
#match-ranking {
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#match-ranking .title {
  font-size: 14px;
  font-weight: 500;
  margin: 8px 0;
}

#match-ranking .match-ranking-box {
  background: #FFFFFF;
  border-radius: 8px;
  width: 351px;
  /* height: 404px; */
  padding: 16px;
}

#match-ranking .match-ranking-box .top-three {
  background: #FBFBFC;
  border-radius: 8px;
  width: 319px;
  height: 144px;
  padding: 12px;
  position: relative;
}

#match-ranking .match-ranking-box .top-three div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#match-ranking .overflow-text-two {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

#match-ranking .match-ranking-box .top-three .one {
  width: 96px;
  height: 108px;
  background-image: url('http://images.snsports.cn/banma_two.png');
  background-size: 100% 108px;
  position: absolute;
  bottom: 12px;
}

#match-ranking .match-ranking-box .top-three .one img {
  margin-top: 12px !important;
}

#match-ranking .match-ranking-box .top-three img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-top: 12px;
}

#match-ranking .match-ranking-box .top-three p {
  font-size: 14px;
  font-weight: 500;
  color: #191919;
  padding: 0 16px;
  height: 42px;
}


#match-ranking .match-ranking-box .top-three .two {
  width: 119px;
  height: 118px;
  background-image: url('http://images.snsports.cn/banma_noe.png');
  background-size: 100% 100%;
  position: absolute;
  bottom: 12px;
  left: 102px;
}

#match-ranking .match-ranking-box .top-three .three {
  width: 92px;
  height: 101px;
  background-image: url('http://images.snsports.cn/banma_three.png');
  background-size: 100% 100%;
  position: absolute;
  bottom: 12px;
  right: 12px;
}
#match-ranking .three img{
width: 40px !important;
height: 40px !important;
}
#match-ranking .three p{
  height: 50px !important;
}

#match-ranking .match-ranking-box .item {
  width: 319px;
  height: 64px;
  background: #F9FAFC;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 14px 17px;
  margin-top: 12px;
}

#match-ranking .match-ranking-box .item div {
  font-size: 16px;
  margin-right: 19px;
}

#match-ranking .match-ranking-box .item img {
  width: 36px;
  height: 36px;
  background: rgba(25, 25, 25, 0);
  border-radius: 7px;
  border: 1px solid #E8E8E8;
  margin-right: 14px;
}

#match-ranking .match-ranking-box .item p {
  font-weight: 500;
  font-size: 14px;
  margin: 0;
}
</style>
